import { useContext } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import { ReactComponent as ReportingPeriodGroupIcon } from '../../assets/icons/Date Year.svg';
import { ReactComponent as ReportingPeriodIcon } from '../../assets/icons/Date Month.svg';
import { ReactComponent as StandardIcon } from '../../assets/icons/Standard.svg';
import PanelReportingPeriodGroups from '../../components/configuration/reporting_period_groups/PanelReportingPeriodGroups';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationReportingPeriodGroups = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  if (!group || !company) return null;

  // Track module duration.
  useModuleDurationTracking('Configuration', 'Reporting Period Groups', group.id, company.id);

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  const dark_teal: string = theme.palette.teal.dark;

  return (
    <Box>
      <ConfigurationWrapper
        title="Reporting Period Groups"
        icon={<ReportingPeriodGroupIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={{
          route: '/configuration/reporting-periods',
          label: 'Reporting Periods',
          icon: <ReportingPeriodIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
        next={{
          route: '/configuration/standards',
          label: 'Standards',
          icon: <StandardIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
      >
        <PanelReportingPeriodGroups />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationReportingPeriodGroups;
